import React from 'react';
import MyProfileLogic from '../components/myprofile/MyProfileLogic';

function MyProfile() {
  return (
    <MyProfileLogic />
  );
}

export default MyProfile;
